import _ from 'lodash';
import Auth0Service from './services/Auth0Service';
import ApiService from './services/ApiService';
import CmsService from './services/CmsService';

const auth0Service = new Auth0Service();
const apiService = new ApiService();
const salesApiService = new ApiService();
const cmsService =new CmsService();

const setLaunchDarklyUser = profile => {
    const ldUser = {
        key: profile.user_id,
        name: profile.name,
        email: profile.email,
    };

    //launchDarklyService.setUser(ldUser);
};

const bootstrap = (config, dispatchAction) => {
    auth0Service.init(config.auth0);
    apiService.init(config.baseUrl, auth0Service);
    salesApiService.init(config.salesBaseUrl);
    cmsService.init(config);
    auth0Service.getProfile();
    auth0Service.on('profile_updated', profile => {
        dispatchAction(profile);
        setApiTokens();
    });

    return Promise.resolve();
};

const setApiTokens = () => {
    const token = auth0Service.getToken();
    apiService.setToken(token);
    salesApiService.setToken(token);
}

export {
    bootstrap as
    default,
    auth0Service,
    apiService,
    salesApiService,
    cmsService
}